<div class="custom-modal-overlay" *ngIf="isVisible" (click)="onOverlayClick($event)">
  <div class="custom-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h3 class="modal-title">{{ title }}</h3>
      <button class="close-button" (click)="onCancel()" type="button">
        <i class="pi pi-times"></i>
      </button>
    </div>
    
    <!-- Modal Content -->
    <div class="modal-content">
      <div class="modal-icon">
        <i class="pi pi-exclamation-triangle"></i>
      </div>
      <div class="modal-message">
        <p>{{ message }}</p>
      </div>
    </div>
    
    <!-- Modal Footer -->
    <div class="modal-footer">
      <button 
        class="btn btn-secondary" 
        (click)="onCancel()" 
        type="button">
        {{ cancelLabel }}
      </button>
      <button 
        class="btn btn-primary" 
        (click)="onConfirm()" 
        type="button">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
